import React from "react";
import { Reveal } from "../shared/Reveal";
import CIISystemDiagram from "../CIISystemDiagram";
import CIIOrbitDiagram from "../CIIOrbitDiagram";

const CII_ITEMS = [
  "Your entire estate on one platform",
  "A single, trusted source of truth",
  "Live intelligence for every team",
  "Waste and anomalies surfaced instantly",
  "Audit-ready ESG & carbon insight",
  "A foundation ready for AI",
];

export default function Beyond() {
  return (
    <section id="beyond" className="arcsec cii">
      <div className="arc top" />
      <div className="arc" />
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">THE STRATEGIC BENEFIT</Reveal>
        <Reveal className="h2 ciihead" tag="div">We Don't Only Save You Money. <span className="g">We Make Your Estate Intelligent.</span></Reveal>
        <Reveal className="lead" tag="p">Reducing energy waste is only the beginning.</Reveal>

        <Reveal className="ciibody" tag="div">
          <p>Our <b>Centralised Intelligence Infrastructure (CII&trade;)</b> brings your buildings, utilities, circuits and critical assets together into one intelligent operational environment — creating a <b>Digital Nervous System</b> across your entire estate.</p>
          <p>Instead of individual buildings operating in isolation, CII&trade; creates a central layer of intelligence that allows leadership, energy, facilities, finance and ESG teams to understand what is happening across the organisation.</p>
        </Reveal>

        <Reveal className="ciiline" tag="div">One building. Ten buildings. Hundreds of buildings. <span className="g">One intelligence infrastructure.</span></Reveal>

        <Reveal className="ciiline sub" tag="div">Just as the human body has a central nervous system, <span className="g">so does your business.</span></Reveal>

        <CIISystemDiagram />

        <Reveal className="ciiline sub" tag="div">Every source, one intelligent core — <span className="g">this is your Digital Nervous System.</span></Reveal>

        <CIIOrbitDiagram />

        <Reveal className="ciisub" tag="div">WHAT CII&trade; DELIVERS</Reveal>
        <div className="ciigrid">
          {CII_ITEMS.map((item, i) => (
            <Reveal className="ciiitem" tag="div" key={item} style={{ transitionDelay: `${(i % 3) * 0.06}s` }} data-testid={`cii-item-${i}`}>
              <span className="dot" /> {item}
            </Reveal>
          ))}
        </div>

        <Reveal className="infocard aicard" tag="div">
          <div className="tagname">THE FOUNDATION FOR AI</div>
          <p style={{ color: "#fff", fontFamily: "Montserrat", fontWeight: 700, fontSize: 19, marginTop: 14 }}>AI is only as intelligent as the information it receives.</p>
          <p>CII&trade; creates the granular, structured, real-time operational data foundation that allows buildings to become increasingly intelligent — identifying patterns, detecting anomalies, supporting predictive maintenance and enabling smarter automated decision-making.</p>
        </Reveal>

        <div className="crescendo">
          <Reveal className="c1" tag="div">Today, we make the invisible visible.</Reveal>
          <Reveal className="c2" tag="div">Tomorrow, that intelligence allows your buildings to think, learn and respond.</Reveal>
          <Reveal className="c3" tag="div">Every Building Will Think for Itself.</Reveal>
        </div>

        <Reveal className="finalstatement" tag="div" data-testid="cii-final-statement">
          We don't simply reduce the cost of operating your buildings. <span className="g">We create the intelligence infrastructure for how they will be operated in the future.</span>
        </Reveal>
      </div>
    </section>
  );
}
